"use client";
import React, { useEffect } from "react";
import "./about.css";
import Abotcard from "./Aboutcard/Abotcard";
import ourmission from "../../Images/illustrationnobg(1)(1).svg";
import Contactpage from "../Contactpage/Contactpage";
import { Helmet } from "react-helmet-async";

const Aboutpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Owision - about Owision | Empowering IT & Innovation Globally</title>
        <meta
          name="description"
          content="Discover Owision’s journey of innovation, global IT services, and digital transformation—driving success across Sweden, India, Dubai & beyond.
"
        />
      </Helmet>
      <div className="sectionBackgroundImage">
        <div className="about-banner-page mainContainer ">
          <h1>About us</h1>
          <p>
            Your technology partner that delivers exceptional products with maximum productivity and
            quality.
          </p>
        </div>
        <div className="value-section-content mainContainer">
          <h1>
            Our value <br /> proposition
          </h1>
          <p>
            We deliver world-class software and websites on time, within budget, and at an
            unbeatable price.
          </p>
        </div>
        <hr className="about-card-title" />
        <div className="about-card-section ">
          <div className="about-carddata-content">
            <div className="img-left-content">
              <img src={ourmission} alt="ourmission" />
            </div>
            <div className="right-content">
              <h1>Our Mission</h1>
              <p className="!px-5 md:py-0">
                At Owision, we are driven by a core mission - to empower businesses of all sizes
                with the technological tools they need to thrive in today's dynamic market. Our team
                of skilled and experienced developers, designers, and strategists collaborate
                seamlessly to create software solutions that not only meet but exceed the
                expectations of our clients.
              </p>
            </div>
          </div>

          <Abotcard />
          <div className="mainContainer about-banner-test-page">
            <Contactpage />
          </div>
        </div>
      </div>
    </>
  );
};

export default Aboutpage;
